import setCookie from '../../session/setCookie'

export default function ahcLoginRedirect(currentQuery) {
  setCookie('flowCurrentQuery', currentQuery.query.toString(), 1)

  let params = {
    client_id: process.env.REACT_APP_CRM_API_APP_ID,
    response_type: 'code',
    scope: 'openid PROFILE.READ PROFILE.WRITE PROFILE.WALLET',
    redirect_uri: process.env.REACT_APP_CRM_AUTH_REDIRECT_URL,
    state: 'LI4T3x5b6EJhta4wpk6ju9&nonce=x5L5dT1hF8lZ7UwMhduosM'
  }

  const queryParams = new URLSearchParams()

  // Loop urlParams for undefined values & remove
  for (let key in params) {
    if (typeof params[key] === "undefined") continue
    queryParams.append(key, params[key])
  }

  const url = `${process.env.REACT_APP_CRM_AUTH_PROVIDER_URL}/as/authorization.oauth2?${queryParams.toString()}`

  setTimeout(function(){
    window.location = url
  }, 500)
}


// WEBPACK FOOTER //
// ./src/utilities/profile/accor/ahcLoginRedirect.js